export const ROUTES = {
  HOME: "/",
  ABOUT: "/about-us",
  SERVICE: "/services",
  BLOG: "/blogs",
  BLOG_DETAIL: "/blogs/:slug",
  CAREER: "/careers",
  FAQ: "/faqs",
  CONTACT: "/contact-us",
  TERMS: "/terms-and-conditions",
  PRIVACY: "/privacy-policy",
  NOT_FOUND: "/not-found",
  REST_PATH: "*",
  WEB3FORMS_URL: "https://api.web3forms.com/submit",
};
